<template>
  <div class="selectFilter grid-11" @focusout="hide">
    <input id="serviceType" type="text" class="input" @click="forceAppear" v-model="search" :required="required"
      :readonly="readonly" :placeholder="placeholder" @keyup.enter="cb && cb(search)" @blur="reset()" />
    <ul :class="css" class="sfl" v-if="show" :style="sty">
      <li v-for="(item, i) in filterList" :key="i + 'op'" @click="choice(item)">
        {{ getName(item) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    name: [String, Array],
    css: String,
    text: String,
    required: [String, Boolean],
    readonly: Boolean,
    placeholder: String,
    cb: Function
  },
  data() {
    return {
      search: "",
      select: false,
      show: false,
      sty: "",
    };
  },
  methods: {
    reset() {
      setTimeout(() => this.search = this.select ? this.search: '', 300)
    },
    forceAppear(e) {
      this.select = false
      this.search = ''
      this.show = true;
      this.sty = `top:${e.pageY + 30}px`;
      this.readonly = false
      this.$forceUpdate();
    },
    getName(item) {
      if (Array.isArray(this.name)) {
        let name = "";
        this.name.map((n, i) => (name += i == 0 ? item[n] : " - " + item[n]));
        return name;
      }
      return item[this.name];
    },
    choice(item) {
      this.select = true
      this.search = this.getName(item);
      this.show = false;
      this.$emit("value", item);
      this.readonly = true
    },
    hide() {
      var se = this;
      setTimeout(() => (se.show = false), 300);
    },
  },
  beforeMount() {
    if (this.text) this.search = this.text;
  },
  computed: {
    filterList() {
      if (this.search) {
        const search = this.search.toLowerCase();
        return this.list.filter((item) => {
          for (let field in item) {
            if (item[field] && item[field].toString().toLowerCase().includes(search))
              return item;
          }
        });
      } else return this.list;
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *

.selectFilter
  ul
    box-shadow: $shadow
    position: absolute
    background: $white
    max-height: 400px
    border-radius: 23px
    overflow: auto

    li
      padding: 21px 33px
      border-bottom: 1px solid #eee
      cursor: pointer

      &:hover
        background: $purple
        font-weight: bold
        color: $white
</style>
